import { render, staticRenderFns } from "./CreditorSearch.vue?vue&type=template&id=ddd9ffbe&scoped=true&"
import script from "./CreditorSearch.vue?vue&type=script&lang=js&"
export * from "./CreditorSearch.vue?vue&type=script&lang=js&"
import style0 from "./CreditorSearch.vue?vue&type=style&index=0&id=ddd9ffbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd9ffbe",
  null
  
)

export default component.exports